import { TRUE_PRODUCTION_DOMAIN } from "../../constants";

export const getSnowPlowConfig = () => {
  switch (process.env.APP_ENV) {
    case "production": {
      /**
       * Из-за невозможности перенести логику определения true-prod стенда на сторону коллектора,
       * определяем его по названию домена на котором запущено приложение.
       * Необходимо убрать этот код если будет найдено более гибкое решение.
       * */
      const isTrueProd = window.location.hostname.includes(
        TRUE_PRODUCTION_DOMAIN
      );

      if (isTrueProd) {
        return {
          appId: "prod-stand",
          collectorUrl: "https://rp.rshb.ru/api/clickstreams",
        };
      }

      return {
        appId: "preprod-stand",
        collectorUrl: "https://dev-rp.rshb.ru:8443/api/clickstreams",
      };
    }

    case "rc": {
      return {
        appId: "test-stand",
        collectorUrl: "https://dev-rp.rshb.ru:8443/api/clickstreams",
      };
    }

    case "development":

    default: {
      return {
        appId: "dev-stand",
        collectorUrl: "https://dev-rp.rshb.ru:443/api/clickstreams",
      };
    }
  }
};

export const runSnowPlow = () => {
  const { collectorUrl, appId } = getSnowPlowConfig();

  window.snowplow?.("newTracker", "events", collectorUrl, {
    appId,
    discoverRootDomain: true,
    cookieSameSite: "Lax",
    contexts: {
      webPage: true,
    },
  });
};
